import { createContext } from 'react'

interface EvergreenPageSeo {
  title: string
  heading: string
}

// A page can supply several HeadData components as its content loads. Keep their
// titles consistent without replacing their descriptions, images or canonicals.
const EvergreenPageSeoContext = createContext<EvergreenPageSeo | undefined>(undefined)

export default EvergreenPageSeoContext
